'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @module utils/DateUtils/DateTimeFormat */

/**
 * A _really_ terrible DateTimeFormat mock if it is not available in
 * the browser or node version.
 */
var DateTimeFormat = function () {
  if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
    return Intl.DateTimeFormat;
  }

  // Very bad 'mock' of Intl.DateTimeFormat
  return function () {
    // eslint-disable-line no-shadow
    function DateTimeFormat(locales, formatOptions) {
      _classCallCheck(this, DateTimeFormat);

      this.locales = locales;
      this.options = formatOptions;
    }

    DateTimeFormat.prototype.format = function format(date) {
      return date.toLocaleString();
    };

    return DateTimeFormat;
  }();
}();

exports.default = DateTimeFormat;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/utils/DateUtils/DateTimeFormat.js
// module id = 346
// module chunks = 213534597649335